import React, { useEffect, useState } from 'react';

function NavbarNew({ onNavigate, currentView, onLogoClick }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'Home', view: 'home' },
    { label: 'About', view: 'about_page' },
    { label: 'Projects', view: 'projects_page' },
    { label: 'Blog', view: 'blog' },
    { label: 'Clients', view: 'clients_page' },
    { label: 'Ventures', view: 'ventures_page' },
    { label: 'Contact', view: 'contact_page', accent: true }
  ];

  const handleNavClick = (e, view, sectionId = null) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    onNavigate(view, sectionId);
  };

  const handleLogoPress = () => {
    setIsMobileMenuOpen(false);
    if (onLogoClick) {
      onLogoClick();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className="absolute top-0 right-0 left-0 z-[100] px-4 py-5 sm:px-6 lg:px-10 lg:py-10">
      <div className="relative lg:static">
        <div className="flex items-center justify-between lg:justify-end">
          <button
            type="button"
            onClick={handleLogoPress}
            className="flex items-center lg:hidden"
            aria-label="Go to home page"
          >
            <img
              src="/logo.png"
              alt="RamaInfra Logo"
              className="h-12 w-12 object-contain"
            />
          </button>

          <button
            type="button"
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-black/25 text-white backdrop-blur lg:hidden"
            aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={isMobileMenuOpen}
          >
            <span className="flex flex-col gap-1.5">
              <span className={`block h-[1.5px] w-5 bg-current transition-transform duration-300 ${isMobileMenuOpen ? 'translate-y-[7px] rotate-45' : ''}`}></span>
              <span className={`block h-[1.5px] w-5 bg-current transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
              <span className={`block h-[1.5px] w-5 bg-current transition-transform duration-300 ${isMobileMenuOpen ? '-translate-y-[7px] -rotate-45' : ''}`}></span>
            </span>
          </button>

          <div className="hidden space-x-8 bank-gothic text-xs tracking-[0.2em] text-white/70 lg:flex xl:space-x-12">
            {navItems.map((item) => (
              <button
                key={item.view}
                type="button"
                onClick={(e) => handleNavClick(e, item.view)}
                className={`nav-link-btn hover:text-white transition-colors ${
                  item.accent
                    ? 'accent-text font-bold'
                    : currentView === item.view
                      ? 'text-white'
                      : ''
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <div
          className={`mobile-nav-panel absolute left-0 right-0 top-full z-[110] pt-4 lg:hidden ${
            isMobileMenuOpen ? 'mobile-nav-panel-open' : ''
          }`}
        >
          <div className="rounded-[28px] border border-white/10 bg-[#0f0f0f]/95 p-6 shadow-2xl backdrop-blur">
            <div className="mb-5 flex items-center justify-between">
              <button
                type="button"
                onClick={handleLogoPress}
                className="bank-gothic text-[11px] tracking-[0.35em] text-white"
              >
                HOME
              </button>
              <span className="bank-gothic text-[10px] tracking-[0.3em] text-neutral-500">
                MENU
              </span>
            </div>

            <div className="flex flex-col gap-4 bank-gothic text-xs tracking-[0.28em] text-white/80">
              {navItems.map((item) => (
                <button
                  key={item.view}
                  type="button"
                  onClick={(e) => handleNavClick(e, item.view)}
                  className={`rounded-full border px-4 py-3 transition-colors ${
                    currentView === item.view
                      ? 'border-[#c49b66] text-white'
                      : 'border-white/10 hover:border-white/30 hover:text-white'
                  } ${item.accent ? 'text-[#c49b66]' : ''}`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavbarNew;
